<student-documents-v9 style="display: flex;flex: 1;flex-direction: column;" *ngIf="!isV10"></student-documents-v9>
<student-documents-v10 style="display: flex;flex: 1;flex-direction: column;" *ngIf="isV10"></student-documents-v10>

